import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
    EmvioValidatedInput,
    EmvioValidatedButton,
    EmvioValidatedForm
} from '@nexio/emvio-form-components';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { toastIfError } from '../../utils/toast';
import { createAccount } from './signupActions';
import { updateEmail } from '../Login/loginActions';
import { getEmail } from '../Login/loginViewState';
import {
    getIsLoading,
    getCreateAccountError,
    getWasAccountCreatedSuccessfully,
    getCreateAccountErrorMessage
} from './signupEntity';
import { historyShape } from '../../utils/propTypes';
import '../Login/Login.scss';
import '../Login/LoginForm/LoginForm.scss';
import { Link } from 'react-router-dom';

export class Signup extends Component {
    static propTypes = {
        history: historyShape,
        isLoading: PropTypes.bool,
        createAccountError: PropTypes.bool,
        wasAccountCreatedSuccessfully: PropTypes.bool,
        onCreateAccount: PropTypes.func,
        createAccountErrorMessage: PropTypes.string,
        email: PropTypes.string,
        onUpdateEmail: PropTypes.func
    };

    state = {
        firstName: '',
        lastName: '',
        accountAdminEmail: '',
        company: '',
        websiteUrl: ''
    };

    componentDidMount() {
        const env = process.env.BUILD_ENV;

        this.replaceHistoryOnProd(env);
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'createAccountErrorMessage');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'wasAccountCreatedSuccessfully') && this.props.wasAccountCreatedSuccessfully) {
            this.props.history.replace('/');
        }
    }

    replaceHistoryOnProd = (env) => {
        if (env === 'production') {
            this.props.history.replace('/');
        }
    };

    onUpdateFirstName = (e) => {
        this.setState({
            firstName: e.target.value
        });
    };

    onUpdateLastName = (e) => {
        this.setState({
            lastName: e.target.value
        });
    };

    onUpdateCompany = (e) => {
        this.setState({
            company: e.target.value
        });
    };

    onUpdateWebsiteUrl = (e) => {
        this.setState({
            websiteUrl: e.target.value
        });
    };

    onSubmit = () => {
        const accountName = this.state.company;
        const merchantName = this.state.company;
        const accountAdminEmail = this.props.email;
        const firstName = this.state.firstName;
        const lastName = this.state.lastName;
        const websiteUrl = this.state.websiteUrl ? this.state.websiteUrl : null;

        this.props.onCreateAccount(accountName, merchantName, accountAdminEmail, firstName, lastName, websiteUrl);
    };

    render() {

        return (
            <div className="emvio-login">
                <div className="login-container">
                    <div className="logo"/>
                    <div className="subtitle">
                        Create your Nexio Sandbox account
                    </div>
                    <EmvioValidatedForm  onSubmit={this.onSubmit}>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoFocus
                                autoCapitalize="off"
                                autoCorrect="off"
                                labelText="First Name *"
                                name="firstName"
                                onChange={this.onUpdateFirstName}
                                placeholder="First Name *"
                                shouldNotTrim
                                type="text"
                                validations={['required']}
                                value={this.state.firstName}
                            />
                        </div>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoCorrect="off"
                                labelText="Last Name *"
                                name="lastName"
                                onChange={this.onUpdateLastName}
                                placeholder="Last Name *"
                                shouldNotTrim
                                type="text"
                                validations={['required']}
                                value={this.state.lastName}
                            />
                        </div>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoCorrect="off"
                                labelText="Email *"
                                name="email"
                                onChange={this.props.onUpdateEmail}
                                placeholder="Email *"
                                shouldEnforceLowerCase={true}
                                type="text"
                                validations={['email', 'required']}
                                value={this.props.email || ''}
                            />
                        </div>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoCorrect="off"
                                labelText="Company Name *"
                                name="company"
                                onChange={this.onUpdateCompany}
                                placeholder="Company Name *"
                                shouldNotTrim
                                type="text"
                                validations={['required']}
                                value={this.state.company}
                            />
                        </div>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoCorrect="off"
                                labelText="Company Website (optional)"
                                name="websiteUrl"
                                onChange={this.onUpdateWebsiteUrl}
                                placeholder="Company Website (optional)"
                                shouldNotTrim
                                type="text"
                                validations={[]}
                                value={this.state.websiteUrl}
                            />
                        </div>
                        <div className="required-tag">
                            *required
                        </div>
                        <EmvioValidatedButton isLoading={this.props.isLoading}>
                            CREATE ACCOUNT
                        </EmvioValidatedButton>
                        <div>
                            <div >
                                <span className="login-or"><hr className="login-split left"/>OR<hr className="login-split right"/></span>
                                <span className="signup-link-container">Already have an account?<Link to="/" className="signup-link">Sign In</Link></span>
                            </div>
                        </div>
                    </EmvioValidatedForm>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        isLoading: getIsLoading(state),
        createAccountError: getCreateAccountError(state),
        wasAccountCreatedSuccessfully: getWasAccountCreatedSuccessfully(state),
        createAccountErrorMessage: getCreateAccountErrorMessage(state),
        email: getEmail(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onCreateAccount: (accountName, merchantName, accountAdminEmail, firstName, lastName, websiteUrl) => dispatch(createAccount(accountName, merchantName, accountAdminEmail, firstName, lastName, websiteUrl)),
        onUpdateEmail: (e) => dispatch(updateEmail(e.target.value))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup));
